(() => {
  const CODE = /\(([A-Z]{3})\)/;

  const shorten = () => {
    document.querySelectorAll('.currency-switcher > div > span').forEach((label) => {
      const match = label.textContent.match(CODE);
      if (match && label.textContent !== match[1]) label.textContent = match[1];
    });
  };

  new MutationObserver(shorten).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
  shorten();
})();
